import React, { useContext } from 'react';
import { Box } from '@mui/material';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import { DataContext } from '../../context/DataContext';
import { getTokens } from '../../theme';

// Buscador de las pantallas de listado — ver los .dc.html del handoff:
// alto 44px, radio 11px, fondo var(--field) con borde var(--field-border),
// icono de lupa 17px en color faint y el input sin borde propio.
const SearchField = ({ value, onChange, placeholder = 'Buscar…', width = 300 }) => {
	const { isDarkMode } = useContext(DataContext);
	const t = getTokens(isDarkMode);

	return (
		<Box
			sx={{
				display: 'flex',
				alignItems: 'center',
				gap: '11px',
				backgroundColor: t.field,
				border: `1px solid ${t.fieldLine}`,
				borderRadius: '11px',
				padding: '0 14px',
				height: '44px',
				width: { xs: '100%', sm: width },
				maxWidth: '100%'
			}}
		>
			<SearchRoundedIcon sx={{ fontSize: 17, color: 'text.disabled' }} />
			<Box
				component="input"
				value={value}
				onChange={(e) => onChange(e.target.value)}
				placeholder={placeholder}
				sx={{
					flex: 1,
					border: 'none',
					outline: 'none',
					backgroundColor: 'transparent',
					fontFamily: 'inherit',
					fontSize: 14,
					color: 'text.primary',
					minWidth: 0
				}}
			/>
		</Box>
	);
};

export default SearchField;
